<template>
	<div id="support">
		
		<h3>QDS Live Support</h3>
		<p>Hi! Are you facing an issue? Do you need platform related support? Or do you want a feature to be added to QDS Pro?</p>
		<p>Feel free to message us and we will get back to you instantly. Our Team is available to help you at all times.</p>

		<div v-if="loading">
			<p>Please wait while we load the Support System...</p>
			<loader v-if="loading"></loader>	
		</div>
		

	</div>
</template>

<script>
import Loader from '../Loader.vue';

export default {
	name:'Support',
	components: {
		Loader
	},
	data: function() {
		return {
			loading:true
		}
	},
	computed: {
		me: function() {
			return this.$store.getters.user;
		}
	},
	mounted() {
		

		this.loading= true;

		zE('webWidget', 'identify', {
		    name: this.me.full_name,
		    email: this.me.email
		});

	  	var inter = setInterval(()=>{
	  		if(typeof window.zE !== 'undefined') {
	  			this.loading = false;
	  			zE('webWidget', 'show');
	  			zE('webWidget', 'open');
	  			clearInterval(inter);
	  		}
	  	}, 100)
	},
	beforeDestroy() {
		zE('webWidget', 'hide');
		zE('webWidget', 'close');
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Support.vue